/*
 * FractalAI bilingual rollout header.
 *
 * 文件定位 / File Purpose
 * - 中文：报告中心注册表，集中定义报告分类标签、导航入口和策略中心报告入口集合。
 * - English: Report-center registry that centralizes category labels, navigation entries, and report-entry sets used by strategy pages.
 *
 * 调用关系 / Call Flow
 * - 中文：由报告阅读页、策略中心和研究导航读取。
 * - English: Read by report-reader pages, the strategy library, and research navigation.
 *
 * 数据与业务边界 / Data and Business Boundaries
 * - 中文：仅运行在浏览器侧或 Umi 构建侧，不直接访问数据库、不写 SQL、不复制服务端分型核心算法。
 * - English: Runs only in the browser or Umi build layer; it does not access databases, write SQL, or copy server-side fractal-core algorithms.
 *
 * 上线注意 / Release Notes
 * - 中文：作为智能研究工作台前端上线清单的一部分，修改时必须保持路由、白名单登录、报告/策略入口和生产构建校验一致。
 * - English: Part of the intelligence-workbench frontend rollout scope; keep routes, whitelist login, report/strategy entry points, and production-build checks aligned.
 */

export const REPORT_CATEGORY_LABELS = {
  report: '策略报告',
  long_term_monitor: '长期监控',
  legacy_long_term_monitor: '长期监控',
  attribution_report: '归因报告',
  post_market_hotspot_report: '热点报告',
  prediction_feedback_report: '预测反馈报告',
  uptrend_end_monitor: '上升波段结束确认',
};

export const REPORT_NAV_ITEMS = [
  {
    key: 'all',
    label: '全部报告',
    path: '/reports/list',
    description: '查看全部研究输出、文件目录和下载入口。',
    tag: 'Reports',
    tagColor: 'processing',
  },
  {
    key: 'hotspot',
    label: '热点报告',
    path: '/reports/hotspot',
    category: 'post_market_hotspot_report',
    description: '直接阅读盘后热点强弱、拥挤程度和风险提示。',
    tag: 'Hotspot',
    tagColor: 'orange',
  },
  {
    key: 'attribution',
    label: '归因报告',
    path: '/reports/attribution',
    category: 'attribution_report',
    description: '直接阅读策略信号背后的行业、主题、概念和新闻归因。',
    tag: 'Attribution',
    tagColor: 'geekblue',
  },
  {
    key: 'strategy',
    label: '策略报告',
    path: '/reports/category/report',
    category: 'report',
    description: '按策略报告分类查看研究输出。',
    tag: 'Strategy',
    tagColor: 'purple',
  },
  {
    key: 'long-term',
    label: '长期监控',
    path: '/reports/category/long_term_monitor',
    category: 'long_term_monitor',
    description: '查看长期监控类研究输出。',
    tag: 'Monitor',
    tagColor: 'gold',
  },
  {
    key: 'archive',
    label: '报告归档',
    path: '/reports/archive',
    description: '进入报告归档和分类回看。',
    tag: 'Archive',
    tagColor: 'default',
  },
];

export const REPORT_LIBRARY_ENTRY_KEYS = [ 'all', 'hotspot', 'attribution', 'archive' ];

export const getReportCategoryLabel = category =>
  REPORT_CATEGORY_LABELS[category] || category || '研究文件';

export const getReportNavItem = key => REPORT_NAV_ITEMS.find(item => item.key === key);

export const getReportNavItemsByKeys = keys =>
  keys.map(getReportNavItem).filter(Boolean);
